// This icon file is generated automatically.
var PtoClearOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M28.1 27.18l-1.66-9.55H27c.45 0 .81-.37.81-.82v-6A.81.81 0 0027 10h-7.69V4.31a.81.81 0 00-.81-.81h-5a.81.81 0 00-.81.81V10H5a.81.81 0 00-.81.81v6c0 .45.36.82.81.82h.56L3.9 27.18a.81.81 0 00.8.95h22.6c.04 0 .1 0 .13-.02a.8.8 0 00.67-.93zm-21.73-15h8.5v-6.5h2.26v6.5h8.5v3.26H6.38v-3.25zM21 25.95v-4.88a.25.25 0 00-.25-.25h-1.5a.25.25 0 00-.25.25v4.88h-6v-4.88a.25.25 0 00-.25-.25h-1.5a.25.25 0 00-.25.25v4.88H6.34l1.4-8.13h16.51l1.4 8.13H21z", "fill-rule": "nonzero" } }] }, "name": "pto-clear", "theme": "outlined" };
export default PtoClearOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoClearOutlined.js
// module id = 3897
// module chunks = 0